import TokenProvider from "./contexts/Token"
import PopupProvider from "./contexts/Popup"

import NotLoggedIn from "./layouts/NotLoggedIn"
import LoggedIn from "./layouts/LoggedIn"
import PageNotFound from "./pages/PageNotFound"
import Home from "./pages/Home"
import Login from "./pages/Login"
import Register from "./pages/Register"
import FaceList from "./pages/FaceList"
import UserList from "./pages/UserList"

import { BrowserRouter, Routes, Route } from "react-router-dom"

function App() {
  return (
    <BrowserRouter>
      <TokenProvider>
        <PopupProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<NotLoggedIn><Login /></NotLoggedIn>} />
            <Route path="/register" element={<NotLoggedIn><Register /></NotLoggedIn>} />
            <Route path="/face-list" element={<LoggedIn><FaceList /></LoggedIn>} />
            <Route path="/user-list" element={<LoggedIn><UserList /></LoggedIn>} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </PopupProvider>
      </TokenProvider>
    </BrowserRouter>
  )
}

export default App;
